import type { FunctionComponent, PropsWithChildren } from 'react';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import { GlobalNav } from '@fff-web/fff-global-nav';
import env from '../../config/env';
import * as styles from './Layout.module.css';

const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <div className={styles.layoutContainer}>
    <GlobalNav env={env.ENVIRONMENT} />
    <main data-testid="layout-main">{children}</main>
    <GlobalFooter chatbotConfig={{ agentId: env.CHATBOT_AGENT_ID }} />
  </div>
);

export default Layout;
